/**
 * 将一个 map 转化成 select 组件可消费的 data 类型
 */
export const getSelectOptionsFromMap = (map) => {
  const keyValues = Object.entries(map);
  return keyValues.map(([value, label]) => ({ label, value }));
};
